import { jsx as p } from "react/jsx-runtime";
import { components as s } from "react-select";
const { Option: e } = s, m = ({
  children: o,
  innerProps: t,
  ...n
}) => /* @__PURE__ */ p(
  e,
  {
    ...n,
    innerProps: (
      // We need to cheat here a bit to pass title to the root element for option as it's not officially
      // supported but all innerProps are added to the root element.
      {
        ...t,
        title: typeof o == "string" ? o : void 0,
        // The built-in hover/focus styling logic for react-select causes performance issues
        // that make select really slow if it contains many options (e.g. >500 options)
        // https://github.com/JedWatson/react-select/issues/3128
        //
        // Instead of these methods we use CSS selectors for hover and focus
        // along with event listeners on the parent container to switch between
        // mouse hover styling and keyboard focus styling
        onMouseMove: () => ({}),
        onMouseOver: () => ({})
      }
    ),
    children: o
  }
);
export {
  m as Option
};
//# sourceMappingURL=Option.js.map
